// extracted by mini-css-extract-plugin
export default {"breakpoint_tablet_max_width_1199":"1199px","no_filter_result":"fas_no_filter_result","buttons":"fas_buttons","button":"fas_button","edit_filter_btn":"fas_edit_filter_btn"};